import Store from '@app/store';
import helpers from '@app/global/helpers';
var VueGlobal = null;
export default {
    install: function (Vue) {
        VueGlobal = Vue;
        // Install global variables
        // Available as global and instance properties
        this.setGlobal('helpers', helpers);
        this.setGlobal('user', window.FRONTEND_USER);
        this.setGlobal('pageTransitionDuration', 1000);
        this.setGlobal('store', Store);
    },
    setGlobal: function (name, val) {
        VueGlobal[name] = val;
        VueGlobal.prototype["$" + name] = val;
    }
};
